import React, { useEffect, useState } from "react";
import { MdDelete, MdModeEditOutline } from "react-icons/md";
import "../../css/Admin-PhotoGallery/AdminPhotoGalleryCard.css";
import AdminEditPhotoGallery from "./AdminEditPhotoGallery";
import { toast } from "react-toastify";
import { deleteDoc, doc } from "firebase/firestore";
import { db } from "../../firebase";

const AdminPhotoGalleryCard = ({ data, fetchData,projectKey }) => {
  const [editProject, setEditProject] = useState(false);

  const handleDelete = async () => {
    if (window.confirm("Are you sure you want to delete this Image?")) {
      try {
        await deleteDoc(doc(db, "photoGallery", projectKey));
        toast.success("Image deleted successfully");
        fetchData();
      } catch (error) {
        toast.error("Failed to delete Image");
      }
    }
  };


  return (
    <div className="product-container">
      <div className="product-card">
        <div className="product-image-div">
          <img
            src={data.PhotoGalleryImage}
            alt={data.PhotoGalleryImage}
            className="product-image"
          />
        </div>
        <h1 className="product-name">{data.photoType}</h1>
        <p className="product-description">{data.photoGalleryName}</p>
        <div className="product-buttons">
          

          <div className="edit-button" onClick={() => setEditProject(true)}>
            <MdModeEditOutline style={{fontSize:'1.5rem' }}/>
          </div>

          <div className="delete-button" onClick={handleDelete}>
            <MdDelete style={{ fontSize: "1.5rem" ,color:"white"}} />
          </div>

        </div>
      </div>

      {editProject && (
                <AdminEditPhotoGallery onClose={() => setEditProject(false)} productData={data} fetchData={fetchData} projectKey={projectKey}/>
            )}
    </div>
  );
};

export default AdminPhotoGalleryCard;
